<template>
  <v-card flat>
    <v-select
      :label="display_type === 'first_second' ? $t('message.lang_pair_select.first_lang') : $t('message.lang_pair_select.source_lang')"
      class="mb-2"
      :items="source_langs"
      item-text="label"
      item-value="value"
      v-model="lang_pair.source_lang"
      @input="$emit('update_lang_pair', update_source_lang())"
    >
      <template v-slot:item="props">
        {{ $t('message.common.lang_' + props.item.label) }}
      </template>
      <template v-slot:selection="props">
        <v-list-item class="pa-2 pl-0" style="min-height:auto">
          {{ $t('message.common.lang_' + props.item.label) }}
        </v-list-item>
      </template>
    </v-select>

    <template v-if="display_type !== 'source'">
      <v-tooltip top>
        <template v-slot:activator="{ on: onTooltip }">
          <v-icon
            v-on="onTooltip"
            @click="excahnge_langs">
            mdi-swap-vertical-bold
          </v-icon>
        </template>
        <span>{{ $t("message.lang_pair_select.excahnge_langs") }}</span>
      </v-tooltip>

      <v-select
        ref="target_lang"
        class="mt-2"
        :label="display_type === 'first_second' ? $t('message.lang_pair_select.second_lang') : $t('message.lang_pair_select.target_lang')"
        :items="target_langs"
        item-text="label"
        item-value="value"
        v-model="lang_pair.target_lang"
        @input="$emit('update_lang_pair', lang_pair)"
      >
        <template v-slot:item="props">
          {{ $t('message.common.lang_' + props.item.label) }}
        </template>
        <template v-slot:selection="props">
          <v-list-item class="pa-2 pl-0" style="min-height:auto">
            {{ $t('message.common.lang_' + props.item.label) }}
          </v-list-item>
        </template>
      </v-select>
    </template>
  </v-card>
</template>

<script>
export default {
  name: 'lang_pair_select',
  props: {
    lang_pair: Object,
    lang_pairs: Object,
    display_type: String, // "source_target" or "first_second", "source"
  },
  data: function(){
    return {
      module_id: "74"
    }
  },
  methods: {
    excahnge_langs: function(){
      var old_source_lang = this.lang_pair.source_lang;
      if(this.lang_pair.target_lang in this.lang_pairs){
        this.lang_pair.source_lang = this.lang_pair.target_lang;
      }else{
        this.$store.commit("setNotification", {
          type: "warning",
          message: {
            eid: "E174105:00000001",
            param: {
              source_lang: this.lang_pair.target_lang,
              target_lang: this.lang_pair.source_lang
            }
          }
        });
        return; // 何もしない
      }
      if(this.lang_pairs[this.lang_pair.source_lang].indexOf(old_source_lang) >= 0){
        this.lang_pair.target_lang = old_source_lang;
      }else{
        this.$store.commit("setNotification", {
          type: "warning",
          message: {
            eid: "E174105:00000002",
            param: {
              source_lang: this.lang_pair.target_lang,
              target_lang: this.lang_pair.source_lang
            }
          }
        });
        this.lang_pair.source_lang = old_source_lang; //元に戻す
      }
      this.$emit('update_lang_pair', this.lang_pair);
    },
    update_source_lang: function(){
      var target_lang = "";
      if(this.lang_pair.source_lang in this.lang_pairs
        && this.lang_pairs[this.lang_pair.source_lang].length > 0){
        target_lang = this.lang_pairs[this.lang_pair.source_lang][0];
      }
      return {
        source_lang: this.lang_pair.source_lang,
        target_lang: target_lang
      }
    }
  },
  computed: {
    source_langs: function(){
      var langs = [];
      for(var source_lang in this.lang_pairs){
        langs.push({
          "label": source_lang,
          "value": source_lang
        });
      }
      langs.sort(function(a, b){
        if (this.$i18n.t('message.common.lang_' + a.label) > this.$i18n.t('message.common.lang_' + b.label)) {
          return 1;
        }else{
          return -1;
        }
      }.bind(this));
      return langs;
    },
    target_langs: function(){
      if(!(this.lang_pair.source_lang in this.lang_pairs)){
        return [];
      }
      var langs = [];
      for(var target_lang of this.lang_pairs[this.lang_pair.source_lang]){
        langs.push({
          "label": target_lang,
          "value": target_lang
        });
      }
      langs.sort(function(a, b){
        if (this.$i18n.t('message.common.lang_' + a.label) > this.$i18n.t('message.common.lang_' + b.label)) {
          return 1;
        }else{
          return -1;
        }
      }.bind(this));
      return langs;
    }
  }
}
</script>
